module.exports = __webpack_public_path__ + "img/8.52ac9d1e.jpg";